/* Copyright 2013 - 2022 Waiterio LLC */
import STAGING from './STAGING.js'
import ENVIRONMENT from './ENVIRONMENT.js'

export default ENVIRONMENT === STAGING
